module.exports = __webpack_public_path__ + "static/img/US@2x.2504fb2d.jpg";